import { Banner } from '../microcms/model';

export const getLink = (banner: Banner) => {
  if (banner.campaign) {
    return `/campaign/${banner.campaign.id}` || '';
  }
  if (banner.blog) {
    return `/blog/${banner.blog.id}` || '';
  }
  if (banner.news) {
    return `/news/${banner.news.id}` || '';
  }
  return banner.linkPath || '';
};
